<template>
  <div class="wrap reserve-change-wrap">
    <Loading :visible="isLoadingPop"></Loading>
    <div class="top-header">
      <incBack></incBack>
      <h3>코칭 방법/날짜 변경하기</h3>
    </div>
    <div class="body-wrap">
      <!-- <h5>예약 가능 회기 <span class="bold">5</span></h5> -->
      <div class="mt-40">
        <h4>코칭 방법을 선택해 주세요!</h4>
        <!-- 코칭 주제 선택 -->
        <ul>
          <li>
            <select name="" id="" v-model="input.sessionType" @change="typeChange()">
              <option value="전화">전화 코칭 (전화)</option>
              <option value="화상">화상 코칭 (화상)</option>
              <option value="대면">대면 코칭(오프라인)</option>
            </select>
          </li>
        </ul>
      </div>
      <div class="clear mt-40" v-if="input.sessionType == '대면'">
        <h4>어디서 코칭을 받고 싶나요?</h4>
        <div class="w-50per float-left">
          <ul>
            <li>
              <select name="" id="" v-model="tempSi">
                <option v-for="(item, index) in sido.sido" :key="index" :value="index">{{ item }}</option>
              </select>
            </li>
          </ul>
        </div>
        <div class="w-50per float-left">
          <ul>
            <li>
              <select name="" id="" v-model="tempGu">
                <option :value="index" v-for="(item, index) in sido.gun[tempSi]" :key="index">{{ item }}</option>
              </select>
            </li>
          </ul>
        </div>
      </div>

      <!-- 코칭 날짜 선택 -->
      <div class="calendar-wrap mt-40">
        <h4>희망 날짜와 시간을 선택해 주세요!</h4>
        <DatePicker
          is-expanded
          style="border: none"
          locale="en"
          color="green"
          v-model="tempDate"
          :min-date="new Date()"
        ></DatePicker>
      </div>
      <!-- 시간 선택 -->
      <div class="time-wrap w-90per mg-auto">
        <h2><img src="@/assets/img/time-icon.svg" alt="" /> Time</h2>
        <select name="time" id="" v-model="tempStartTime">
          <option :value="item.value" v-for="(item, index) in timeTable" :key="index">{{ item.text }}</option>
        </select>
        <span>~</span>
        <select name="time" id="" v-model="tempEndTime">
          <option :value="item.value" v-for="(item, index) in timeTable" :key="index">{{ item.text }}</option>
        </select>
      </div>

      <div class="bnb-btn" style="position: static; margin-top: 30px">
        <!-- 선택 시 class="active" 활성화 -->
        <button class="active" @click="next()">NEXT</button>
        <!-- <p class="txt-blue">
                    혹시 주제가 맘에 안든다면? <br>
                    서베이를 한번 더 해볼 수 있어요!
                </p> -->
      </div>
    </div>
  </div>
</template>
<script>
import { sidogun } from "@/utils/sido.js";
import incBack from "@/components/inc/inc_back.vue";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import dayjs from "dayjs";
import Loading from "@/components/inc/inc_loading.vue";
export default {
  name: "reservation_change",
  props: {
    sessionIdx: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    timeTable: [],
    input: {
      sessionIdx: 0,
      sessionType: "",
      sessionCity: "",
      sessionGu: "",
      startDatetime: "",
      endDatetime: "",
      courseIdx: 0,
    },
    course: {},
    tempDate: "",
    tempStartTime: "",
    tempEndTime: "",
    tempSi: 0,
    tempGu: 0,
    sido: {},
    isLoadingPop: false,
  }),
  components: {
    incBack,
    DatePicker,
    Loading,
  },
  mounted() {
    this.sido = sidogun();
    this.timeTable = [];
    for (let hour = 0; hour <= 23; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        // 시간을 2자리 숫자로 표시
        let formattedHour = hour.toString().padStart(2, "0");
        // 분을 2자리 숫자로 표시
        let formattedMinute = minute.toString().padStart(2, "0");

        // 시간을 배열에 추가
        this.timeTable.push({ value: `${formattedHour}:${formattedMinute}`, text: `${formattedHour}:${formattedMinute}` });
      }
    }
    this.getReservation();
  },
  methods: {
    getReservation() {
      let params = {
        sessionIdx: this.sessionIdx,
      };
      this.axios
        .get("/front/coarching/reserved/detail", { params })
        .then((res) => {
          if (res.data.success) {
            this.input.sessionType = res.data.contentinfo.reservedCoachingDetailDto.sessionType;
            this.course = res.data.contentinfo.reservedCoachingDetailDto;

            this.tempDate = new Date(dayjs(res.data.contentinfo.reservedCoachingDetailDto.startDatetime).format("YYYY-MM-DD"));

            this.tempStartTime = dayjs(res.data.contentinfo.reservedCoachingDetailDto.startDatetime).format("HH:mm");
            this.tempEndTime = dayjs(res.data.contentinfo.reservedCoachingDetailDto.endDatetime).format("HH:mm");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    next() {
      this.input.sessionIdx = this.sessionIdx;
      if (this.input.sessionType == "") {
        alert("코칭 방법을 선택해주세요");
        return false;
      }

      if (this.input.sessionType == "대면") {
        this.input.sessionCity = this.sido.sido[this.tempSi];
        this.input.sessionGu = this.sido.gun[this.tempSi][this.tempGu];
        if (this.input.sessionCity == "" || this.input.sessionGu == "") {
          alert("대면 지역을 선택해주세요.");
          return false;
        }
      }

      if (this.tempDate == "") {
        alert("예약하실 날짜를 선택해주세요.");
        return false;
      }

      if (this.tempStartTime == "" || this.tempEndTime == "") {
        alert("예약하실 시간 선택해주세요.");
        return false;
      }
      if (this.tempStartTime == this.tempEndTime) {
        alert("동일한 시간대는 선택할수 없습니다.");
        return false;
      }

      // 시간 순서 비교 code
      const [startHour, startMin] = this.tempStartTime.split(":").map(Number);
      const [endHour, endMin] = this.tempEndTime.split(":").map(Number);

      // 시간 비교
      if (startHour > endHour) {
        alert("시간 지정이 올바르지 않습니다.");
        return false;
      }

      // 분 단위 비교
      if (startHour === endHour) {
        if (startMin > endMin) {
          alert("시간 지정이 올바르지 않습니다.");
          return false;
        }
      }

      this.input.startDatetime = dayjs(this.tempDate).format("YYYY-MM-DD") + " " + this.tempStartTime;
      this.input.endDatetime = dayjs(this.tempDate).format("YYYY-MM-DD") + " " + this.tempEndTime;
      this.input.courseIdx = this.course.courseIdx;

      const startDate = new Date(this.input.startDatetime);
      const endDate = new Date(this.input.endDatetime);

      // 두 날짜 및 시간의 차이 계산
      const timeDifference = endDate.getTime() - startDate.getTime();

      const minutesDifference = Math.floor(timeDifference / (1000 * 60));
      // if (
      //   !confirm(`        진행 방법은 ${this.input.sessionType}
      //   진행 시간은 ${this.input.startDatetime} ~ ${this.input.endDatetime.split(" ")[1]} (${minutesDifference}분)
      //   해당 정보가 맞나요? `)
      // ) {
      //   return false;
      // }

      this.isLoadingPop = true;
      let form = new FormData();
      for (const [key, value] of Object.entries(this.input)) {
        form.append(key, value);
      }

      this.axios
        .post("/front/coarching/reserved/edit/date", form)
        .then((res) => {
          if (res.data.success) {
            alert("예약이 변경되었습니다.");
            this.isLoadingPop = false;
            this.$router.replace({ name: "reservation_coaching_view", params: { idx: Number(this.sessionIdx) } });
          } else {
            this.isLoadingPop = false;
          }
        })
        .catch((err) => {
          this.isLoadingPop = false;
          console.log(err);
        });
    },
    typeChange() {
      this.tempSi = 0;
      this.tempGu = 0;
      this.input.sessionCity = "";
      this.input.sessionGu = "";
    },
  },
};
</script>
<style scoped>
.reserve-change-wrap {
  padding-bottom: 30px;
}
</style>
